var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex overflow-hidden items-center",on:{"click":_vm.onClick}},[_c('div',{staticClass:"w-34 h-38 flex-shrink-0"},[_c('img',{staticClass:"w-full h-full fit-cover",attrs:{"src":_vm.icon}})]),_c('div',{staticClass:"truncate ml-8 flex-auto text-16 leading-20"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }